// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* .data-table {
    height: calc(60vh - 88px) !important;
} */

table {
  width: 100%;
}

.width-100 {
  width: 100%;
}

.data-table-container {
  max-height: 285px !important;
}
/* 
.action-btn {
  height: 35px;

} */

.delete-btn {
  line-height: 16px;
  text-align: center;
  border-radius: 20px;
  top: 3px;
  cursor: pointer;
  position: relative;

}
/* .data-table {
  height: calc(60vh - 88px) !important;
} */

table {
  width: 100%;
}

.width-100 {
  width: 100%;
}

.data-table-container {
  max-height: 285px !important;
}

.action-btn {
  height: 35px;

}

.delete-btn {
  margin-top: 5px;
  /* background-color: #ddd; */
  /* line-height: 22px; */
  text-align: center;
  border-radius: 20px;
  cursor: pointer;
  /* margin-left: 12px; */
  position: relative;

}

.delete-btndiv {
  background-color: #ddd;
  padding: 0px 4px;
  border-radius: 36px;
}

.chartMainClass {
  border: 1px #ddd solid;
  margin: 5px;
  border-radius: 4px;
  padding: 10px;
  background: #fff;
}

.count-text {
  width: max-content;
  margin: 0px auto;
  border: 1px #f2f2f2 solid;
  border-radius: 100px;
  padding: 20px;
}

.feature-text {
  text-align: center;
  color: #003561;
  word-break: break-all;
}

::ng-deep .leaflet-popup-content::-webkit-scrollbar,
.scroll-bar::-webkit-scrollbar,
.mat-drawer::-webkit-scrollbar,
::ng-deep .mat-dialog-container::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::ng-deep .leaflet-popup-content::-webkit-scrollbar-thumb,
.scroll-bar::-webkit-scrollbar-thumb,
.mat-drawer::-webkit-scrollbar-thumb,
::ng-deep .mat-dialog-container::-webkit-scrollbar-thumb {
  background: #003561;
  border-radius: 20px;
}

::ng-deep .leaflet-popup-content::-webkit-scrollbar-track,
.scroll-bar::-webkit-scrollbar-track,
.mat-drawer::-webkit-scrollbar-track,
::ng-deep .mat-dialog-container::-webkit-scrollbar-track {
  background: #ddd;
  border-radius: 20px;
}

::ng-deep .addChartButton {
  padding: 10px;
  padding-left: 30px;
  text-align: left;
}

.div-his {
  width: 100%;
  max-height: 210px;
}

.divtext h2 {
  text-align: center;
  padding-bottom: 10px;
  margin: 5px 0px 15px;
  border-bottom: 1px solid #fed11c;
  font-size: 16px;
  color: #003561;
  font-family: 'Inter Regular';
  font-weight: 500;
}

.closediv {
  position: absolute;
  top: 7px;
  right: 10px;
}

.divtext {
  padding: 5px 5px 0px;
  position: relative;
}

.delete-div {
  background-color: #ddd;
  border-radius: 15px;
  padding: 1px 4px;
  position: relative;

}`, "",{"version":3,"sources":["webpack://./projects/library-common-module/src/lib/chart-table/chart-table.component.css"],"names":[],"mappings":";AACA;;GAEG;;AAEH;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;AACA;;;;GAIG;;AAEH;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;;AAEpB;AACA;;GAEG;;AAEH;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;;AAEd;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;;AAEpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;EAIE,WAAW;EACX,YAAY;AACd;;AAEA;;;;EAIE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;;EAIE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;;AAEpB","sourcesContent":["\n/* .data-table {\n    height: calc(60vh - 88px) !important;\n} */\n\ntable {\n  width: 100%;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n.data-table-container {\n  max-height: 285px !important;\n}\n/* \n.action-btn {\n  height: 35px;\n\n} */\n\n.delete-btn {\n  line-height: 16px;\n  text-align: center;\n  border-radius: 20px;\n  top: 3px;\n  cursor: pointer;\n  position: relative;\n\n}\n/* .data-table {\n  height: calc(60vh - 88px) !important;\n} */\n\ntable {\n  width: 100%;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n.data-table-container {\n  max-height: 285px !important;\n}\n\n.action-btn {\n  height: 35px;\n\n}\n\n.delete-btn {\n  margin-top: 5px;\n  /* background-color: #ddd; */\n  /* line-height: 22px; */\n  text-align: center;\n  border-radius: 20px;\n  cursor: pointer;\n  /* margin-left: 12px; */\n  position: relative;\n\n}\n\n.delete-btndiv {\n  background-color: #ddd;\n  padding: 0px 4px;\n  border-radius: 36px;\n}\n\n.chartMainClass {\n  border: 1px #ddd solid;\n  margin: 5px;\n  border-radius: 4px;\n  padding: 10px;\n  background: #fff;\n}\n\n.count-text {\n  width: max-content;\n  margin: 0px auto;\n  border: 1px #f2f2f2 solid;\n  border-radius: 100px;\n  padding: 20px;\n}\n\n.feature-text {\n  text-align: center;\n  color: #003561;\n  word-break: break-all;\n}\n\n::ng-deep .leaflet-popup-content::-webkit-scrollbar,\n.scroll-bar::-webkit-scrollbar,\n.mat-drawer::-webkit-scrollbar,\n::ng-deep .mat-dialog-container::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n::ng-deep .leaflet-popup-content::-webkit-scrollbar-thumb,\n.scroll-bar::-webkit-scrollbar-thumb,\n.mat-drawer::-webkit-scrollbar-thumb,\n::ng-deep .mat-dialog-container::-webkit-scrollbar-thumb {\n  background: #003561;\n  border-radius: 20px;\n}\n\n::ng-deep .leaflet-popup-content::-webkit-scrollbar-track,\n.scroll-bar::-webkit-scrollbar-track,\n.mat-drawer::-webkit-scrollbar-track,\n::ng-deep .mat-dialog-container::-webkit-scrollbar-track {\n  background: #ddd;\n  border-radius: 20px;\n}\n\n::ng-deep .addChartButton {\n  padding: 10px;\n  padding-left: 30px;\n  text-align: left;\n}\n\n.div-his {\n  width: 100%;\n  max-height: 210px;\n}\n\n.divtext h2 {\n  text-align: center;\n  padding-bottom: 10px;\n  margin: 5px 0px 15px;\n  border-bottom: 1px solid #fed11c;\n  font-size: 16px;\n  color: #003561;\n  font-family: 'Inter Regular';\n  font-weight: 500;\n}\n\n.closediv {\n  position: absolute;\n  top: 7px;\n  right: 10px;\n}\n\n.divtext {\n  padding: 5px 5px 0px;\n  position: relative;\n}\n\n.delete-div {\n  background-color: #ddd;\n  border-radius: 15px;\n  padding: 1px 4px;\n  position: relative;\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
